(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            let product_row = new Swiper('.prod-row-slider', {
              loop: false,
              a11y: false,
              slidesPerView: 'auto',
              scrollbar: {
                el: ".custom-swiper-scrollbar",
                draggable: true,
              },
              grabCursor: true,
              freeMode: true,
              mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
              },
              on: {
                scrollbarDragStart() {
                  document.body.classList.add('dragging');
                },
                scrollbarDragEnd() {
                  document.body.classList.remove('dragging');
                }
              }
            });
            
            $th_refreshWishlistItems();
            if (typeof quickAddButton == 'function') {
              quickAddButton();
            }
            function quickproductrow() {
              if (document.querySelectorAll('.quick_add'))
                document.querySelectorAll('.quick_add').forEach((quick_add) => {
                  quick_add.addEventListener('click', function (e) {
                    e.preventDefault();
                    document.querySelectorAll('.grid-variant-outer').forEach((el) => {
                      el.classList.remove('active-grid-size');
                    });
                    const targetGrid = quick_add.closest('.snippet-product-grid')?.querySelector('.grid-variant-outer');
                    if (targetGrid) targetGrid.classList.add('active-grid-size');
                  });
                });
              document.addEventListener('click', function (e) {
                if (!e.target.closest('.grid-variant-outer') && !e.target.closest('.quick_add')) {
                  document.querySelectorAll('.grid-variant-outer').forEach((el) => {
                    el.classList.remove('active-grid-size');
                  });
                }
              });
            }
            quickproductrow();
            if((/iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent)) &&
            /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
              window.ApplePaySession &&
              ApplePaySession.canMakePayments()
            ) {
              document.querySelectorAll('.pdp-apple-btn, .grid-meta-top-rgt').forEach(function(el) {
                el.style.display = 'flex';
              });
            }
            document.querySelectorAll('.grid-apple-checkout').forEach((grid_apple) => {
              grid_apple.addEventListener('click', function (e) {
                  function isIOS() {
                      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                    }
                    if (isIOS()) {
                      document.querySelectorAll('.snippet-quick-buy-popup').forEach(el => {
                        el.classList.add('ios-click');
                      });
                    }
              });
            });
            document.querySelectorAll('.grid-apple-checkout').forEach((grid_apple) => {
              grid_apple.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if(screen.width > 991){
                  grid_apple.closest('.snippet-product-grid').querySelector('.quick_add').click();
                }else{
                  grid_apple.closest('.snippet-product-grid').querySelector('.quick_view_button').click();
                }
              });
            });
            function bindQuickViewButtons() {
              console.log('click');
              document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
                quickBtn.addEventListener('click', function (e) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  let url = quickBtn.getAttribute('data-url');
                  let modal = quickBtn.getAttribute('data-modal');
                  fetch(url)
                    .then((response) => response.text())
                    .then((response) => {
                      const html = new DOMParser().parseFromString(response, 'text/html');
                      const source = html.getElementById('section-quick-buy');
                      document.body.classList.add('open-quick-buy');
                      document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML =
                        source.innerHTML;
                      addToCart();
                      setTimeout(() => quickviewslider(), 100);
                    })
                    .catch((e) => console.error(e));
                });
              });
            }
            bindQuickViewButtons();
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
